<template>
     <Form class="longterm-wrapper" ref="formDynamic" :model="discountPriceDtoList" :label-width="100">
         <div class="longterm-wrapper-item" v-for="(item, index) in discountPriceDtoList.items">
            <FormItem
                v-if="item.status"
                label="长租优惠价格"
                :prop="'items.' + index + '.stockRentDiscountPrice'"
                :rules="{required: true, validator: validateNumber, trigger: 'blur'}">
                <Input type="text" v-model="item.stockRentDiscountPrice" placeholder="请输入长租优惠价格" style="width:210px" :number="true">
                    <span slot="append">元／月</span>
                </Input>
            </FormItem>
            <FormItem
                v-if="item.status"
                label="生效时间"
                :key="`DatePicker${index}`"
                :prop="'items.' + index + '.time'"
                :rules="{required: true, validator: validatePass, index:index}">
                <Row>
                    <Col>
                        <DatePicker 
                            type="daterange" 
                            v-model="item.time" 
                            placeholder="请选择生效时间" 
                            format="yyyy-MM-dd"
                            style="width:300px" ></DatePicker>
                        <Icon type="minus-circled" style="margin-left:20px;cursor: pointer;" @click.native="handleRemove(index)"></Icon>
                    </Col>
                </Row>
            </FormItem>
         </div>
        
        <FormItem>
            <Row>
                <Col span="12">
                    <Button type="dashed" long @click="handleAdd" icon="plus-round" style="width:150px">添加长租优惠价格</Button>
                </Col>
            </Row>
        </FormItem>
    </Form>
</template>
 
<script type="text/ecmascript-6">
/**
 * @fileoverview 调价-执行涨幅规则
 * @author yanglh1@ziroom.com
 * @wiki http://wiki.ziroom.com/pages/viewpage.action?pageId=636550044
 */
import dayjs from 'dayjs';

export default {
    data () {
        return {
            discountPriceDtoList: {
                items: []
            },
        };
    },
    methods: {
        /**
         * 添加一条长租优惠价格
         */
        handleAdd () {
            this.discountPriceDtoList.items.push({
                stockRentDiscountPrice: '',
                discountBeginTime:'',
                discountEndTime:'',
                time:['',''],
                status: 1
            });
        },
        /** 
         * 删除当前index的长租优惠价格
         * 
         * @export
         * @param {*} index:number 
         * @returns
         */
        handleRemove (index) {
            this.discountPriceDtoList.items[index].status = 0;
        },
        /** 
         * 表单校验
         * 
         * @export
         * @param {*} rule:object 校验规则
         * @param {*} value:array 当前选中的日期
         * @param {*} callback:function 回调函数
         */
        validatePass(rule, value, callback){
            if(value.toString() === ','){
                callback(new Error('请选择生效时间'))
            }else if( this.validatePassTimeOver(rule.index,value) ){
                callback(new Error('时间区间重复') )
            }else{
                callback();
            }
        },
        /** 
         * 表单校验
         * 
         * @export
         * @param {*} rule:object 校验规则
         * @param {*} value:array 当前选中的日期
         * @param {*} callback:function 回调函数
         */
        validateNumber(rule, value, callback) {
            if(!value || typeof value === 'string' || value <= 0){
                callback(new Error('请输入大于0的数字'));
            }
            callback();
        },
        /** 
         * 当前输入的长租有价格列表生效时间与其他生效时间进行重复检查
         * 
         * @param {*} index:number 当前列表index
         * @param {*} time:number  当前输入的长租有价格列表生效时间
         * @returns booleans 
         */
        validatePassTimeOver(index,time) {
            const _discountPriceDtoList = this.discountPriceDtoList.items.filter( (item,i) => index !== i&&item.status);
            return _discountPriceDtoList.some(item => this.checkTimeOverlap(time,item.time) )
        },
        /** 
         * 两个时间重复检查
         * 
         * @param {*} timeA:array 
         * @param {*} timeB:array  
         * @returns booleans 
         */
        checkTimeOverlap(timeA,timeB){
            if(!Array.isArray(timeA)||!Array.isArray(timeB)) return false
            const maxA = new Date(timeA[0]).getTime()
            const maxB = new Date(timeB[0]).getTime()
            const minA = new Date(timeA[1]).getTime()
            const minB = new Date(timeB[1]).getTime()
            const max=[maxA,maxB];
            const min=[minA,minB];
            return (Math.max.apply(null, max)<= Math.min.apply(null, min))
        },
         /** 
         * 设置长租优惠价格数据显示
         * 
         * @param {*} list:array 长租优惠价格的列表数据
         */
        setDiscountPriceDtoList(list=[]) {
            list = list ? list : [];
            if(!Array.isArray(list)) return
            this.$set(this.discountPriceDtoList,'items',[])
            list.forEach((item,index) => {
                this.discountPriceDtoList.items.push({
                    stockRentDiscountPrice:item.stockRentDiscountPrice,
                    discountBeginTime:item.discountBeginTime,
                    discountEndTime:item.discountEndTime,
                    time:[item.discountBeginTime,item.discountEndTime],
                    status: 1
                });
            })
        },
        /** 
         * 获取长租优惠价格数据
         * @returns [] 
         */
        submitDiscountPriceDtoList() {
            let _ = []
            this.discountPriceDtoList.items.forEach( item => {
                if(item.status){
                    _.push({
                        stockRentDiscountPrice:item.stockRentDiscountPrice,
                        discountBeginTime:dayjs(item.time[0]).format('YYYY-MM-DD'),
                        discountEndTime:dayjs(item.time[1]).format('YYYY-MM-DD')
                    }) 
                }
            })
            console.log(_)
            return _
        },
        /** 
         * 获取数据前进行表单校验
         * 
         * @returns booleans
         */
        async validateSubmit () {
            return await this.$refs['formDynamic'].validate( async (valid) => {
                if(valid){
                    return valid
                }else{
                    throw valid
                }
            });
        },
        destroyed () {
            this.$refs['formDynamic'].resetFields()
        }
    }
}
</script>
 
<style lang="css" scoped>
.longterm-wrapper-item{
    display: flex;
}

</style>